import React from 'react'
import AndroidGuide from "../../../assets/AndroidGuide.png"
export default function ErrModal({cancelModal}) {
    return (
        <div className="send-modal-overlay">
      
        <div className="send-modal">
        <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Download Error</p></div> 
        <button
                type="button"
                className="close-button"
                onClick={cancelModal}
                aria-label="Close"
              >
                &times;
              </button>
              <p>There is an error downloading the app. This could be because the app is already installed on your device or your browser does not support it. Please try the guide below.</p>
<div className='lightBlueBanner'><p className='fw-bold p-1'>Download Guide</p></div>

<img
            src={AndroidGuide}
            className="w-75"
            alt="Membotic - All your fitness clubs and activities together"
            title="Membotic - All your fitness clubs and activities together"
          />
       <p>Please use Chrome for this. Press the options button at the top of Chrome (three dots), then select "Add to Home screen."</p>

          <div className="send-modal-footer">
            <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Close
                </button>
            </div>
        
        </div>
      </div>
      )
    }
    

